import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import {
  ArrowUpRight,
  Bell,
  BookOpen,
  ClipboardCheck,
  Layers,
  Sparkles,
  Users,
} from 'lucide-react';

const ACTIONS = [
  {
    to: '/admin/courses',
    label: 'Manage Courses',
    description: 'Curricula, subjects, lessons & publishing',
    icon: BookOpen,
    tone: 'courses',
  },
  {
    to: '/admin/assessments',
    label: 'Manage Assessments',
    description: 'Quizzes, exams & grading workflows',
    icon: ClipboardCheck,
    tone: 'assessments',
  },
  {
    to: '/admin/students',
    label: 'Manage Students',
    description: 'Roster, approvals & learner profiles',
    icon: Users,
    tone: 'students',
  },
  {
    to: '/admin/cohorts',
    label: 'Manage Cohorts',
    description: 'Batch enroll entire classes at once',
    icon: Layers,
    tone: 'cohorts',
  },
  {
    to: '/admin/notifications',
    label: 'Send Notifications',
    description: 'Broadcast updates to your academy',
    icon: Bell,
    tone: 'notifications',
  },
];

const gridVariants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.07, delayChildren: 0.05 },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 22, scale: 0.96 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { type: 'spring', stiffness: 420, damping: 30 },
  },
};

function QuickActionsMenu() {
  const reduceMotion = useReducedMotion();

  return (
    <section className="quick-actions-panel" aria-labelledby="quick-actions-heading">
      <div className="quick-actions-panel-shell">
        <div className="quick-actions-panel-inner">
          <header className="quick-actions-header">
            <div className="quick-actions-header-text">
              <span className="quick-actions-kicker">
                <Sparkles size={12} aria-hidden />
                Command center
              </span>
              <h3 id="quick-actions-heading">Quick Actions</h3>
              <p>
                Your control hub — launch the tools you reach for every day, in one polished motion.
              </p>
            </div>
          </header>

          <motion.div
            className="quick-actions-grid"
            variants={reduceMotion ? undefined : gridVariants}
            initial={reduceMotion ? false : 'hidden'}
            animate={reduceMotion ? false : 'show'}
          >
            {ACTIONS.map((action) => {
              const Icon = action.icon;
              const CardWrapper = reduceMotion ? 'div' : motion.div;
              const motionProps = reduceMotion
                ? {}
                : { variants: cardVariants };

              return (
                <CardWrapper key={action.to} {...motionProps}>
                  <Link
                    to={action.to}
                    className={`quick-action-card quick-action-card--${action.tone}`}
                  >
                    <div className="quick-action-card-top">
                      <span className="quick-action-card-icon" aria-hidden>
                        <Icon size={22} />
                      </span>
                      <ArrowUpRight size={18} className="quick-action-card-arrow" aria-hidden />
                    </div>
                    <div>
                      <span className="quick-action-card-title">{action.label}</span>
                      <span className="quick-action-card-desc">{action.description}</span>
                    </div>
                  </Link>
                </CardWrapper>
              );
            })}
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default QuickActionsMenu;
